import { getLanguages } from '../services';
import { assignmentDecision, getAssignedValue, deflateModelVariables, translateProperty } from '../util';

export const transformToWholeSalerObject = ( cartItems, user, productsStore ) => {
  const config = {
    ConfigurationRequest: {
      ServiceRequest : { ...getServiceRequest( user ) },
      ProductList : { Product: getProductList( cartItems, user, productsStore ) }
    }
  }
  return config;
}

export const getServiceRequest = user => {
  return {
    Action : user.action || "NEW",
    Session : getSession( user ),
    Date : new Date().toLocaleDateString(),
    Receiver : "",
    Sender : { HookURL: user.properties.HookUrl },
    User : { Language: getLanguages().first() },
    Customer : { CustomerCode: user.properties.CustomerCode },
    IntoSite: user.IntoSite || false,
    OneOnlyProduct : user.OneOnlyProduct || false
  }
}

export const getSession = user => {
  return {
    RequestID: user.properties.HookUrl.split('=')[1], // Need to get the user ID or GUID from the Initial Request from the WholeSaler and not from hook URL
    Token: "WholeSales",
    AdditionalInfo: getAdditionalInfo( user )
  }
}
const additionalInfosKey = ["ViewListPrice", "ShowAddToList", "ShowAddToCart", "CartDetailID", "ShowProductView", "ShowStockView", 
      "ShowAvailability", "ShowAvailability", "ShowAddToClientCart", "ShowSendFeedback", "ShowExportPDF", "ShowExportExcel"];
export const getAdditionalInfo = user  => {
  const additionalInfos= additionalInfosKey.map( key => {
    const additionalInfo = {
      Key: key,
      Value: user.properties[ key ]
    }
    return additionalInfo;
  });
  return additionalInfos;
}

export const getProductList = ( cartItems, user, productsStore ) => {
  const products = cartItems.map( cartItem => {
    const product = {
      ProductCode: cartItem.orderCode || cartItem.code,
      ProductDesc: cartItem.description,
      SelectionType: 'SelfAssembly',
      Quantity: cartItem.amount,
      Currency: cartItem.currency,
      ...user.properties['ViewListPrice'] && {ListPrice : cartItem.listPrice},
      ...user.properties['ViewNetPrice'] && {NetPrice : cartItem.netPrice},
      Accessory: cartItem.configuration ? getWholesalerAccessories( cartItem, user, cartItem.amount, productsStore ) : [],
    }
    return product;
  })
  return products;
}

export const getWholesalerAccessories = ( product, user, amount, productsStore ) => {
  const lang = getLanguages().first();
  const accessories = deflateModelVariables( product.configuration.model );
  const userAssignedAccessories = accessories.filter( accessory => 
    assignmentDecision( product.configuration.productModelType, lang )( accessory ) && 
    getAssignedValue( accessory ) !== product.configuration.product.name
  );
  const accessoriesObject = userAssignedAccessories.map( userAssignedAccessory => {
    const accessory = {
      Quantity: amount,
      AccessoryCode:productsStore[userAssignedAccessory.assignedValue.name].orderCode || productsStore[userAssignedAccessory.assignedValue.name].code,
      AccessoryDesc: translateProperty( userAssignedAccessory.assignedValue.properties, userAssignedAccessory.assignedValue.name ),
      AccessorySapLevel: userAssignedAccessory.sapLevel || 1,
      AccessoryParent: userAssignedAccessory.fullyQualifiedName,
      AccessoryParentComponent: product.configuration.materialKey,
      Currency: productsStore[userAssignedAccessory.assignedValue.name].currency,
      ...user.properties['ViewListPrice'] && {ListPrice : userAssignedAccessory.listPrice|| productsStore[userAssignedAccessory.assignedValue.name].listPrice},
      ...user.properties['ViewNetPrice'] && {NetPrice : userAssignedAccessory.netPrice|| productsStore[userAssignedAccessory.assignedValue.name].netPrice}
    }
    return accessory;
  })
  return accessoriesObject;
}